module.exports = __webpack_public_path__ + "media/buy_report_icons/check-96d04038.svg";